import { FormikErrors } from "formik";
import { isValidCIDR } from "./CidrValidation";
import { SubnetMap, SubnetRule, PublicSubnet } from "./Types";

export const isValidSubnetRule = ({ publicCidr, privateCidr }: SubnetRule) =>
  isValidCIDR(publicCidr) && (!privateCidr || isValidCIDR(privateCidr));

export const getSubnetValue = (
  values: SubnetMap,
  subnetRule: Pick<SubnetRule, "ruleId" | "siteId">
): SubnetRule | undefined => {
  let rule: SubnetRule | undefined;

  // Rule is found if:
  // 1. private subnet rule id matches provided subnet rule id
  // 2. public subnet rule id matches provided subnet rule id and it doesn't have any private subnets
  values.publicSubnets.forEach(({ ruleId, cidr, privateSubnets }) => {
    const privateSubnet = privateSubnets.find(
      ({ ruleId }) => ruleId === subnetRule.ruleId
    );
    if (
      privateSubnet ||
      (ruleId === subnetRule.ruleId && privateSubnets.length === 0)
    ) {
      rule = {
        siteId: subnetRule.siteId,
        ruleId: subnetRule.ruleId,
        publicCidr: cidr,
        privateCidr: privateSubnet?.cidr ?? null
      };
    }
  });

  return rule;
};

export const subnetCidrsMatch = (subnet1: SubnetRule, subnet2: SubnetRule) => {
  return (
    subnet1.publicCidr === subnet2.publicCidr &&
    subnet1.privateCidr === subnet2.privateCidr
  );
};

export const hasDuplicates = (values: SubnetMap, subnetRule: SubnetRule) => {
  let hasDuplicates = false;
  values.publicSubnets
    .filter(({ cidr }) => cidr === subnetRule.publicCidr)
    .forEach(({ ruleId, privateSubnets }) => {
      hasDuplicates =
        hasDuplicates ||
        (!privateSubnets.length &&
          !subnetRule.privateCidr &&
          ruleId !== subnetRule.ruleId) ||
        privateSubnets.filter(
          ({ ruleId, cidr }) =>
            cidr === subnetRule.privateCidr &&
            ruleId &&
            ruleId !== subnetRule.ruleId
        ).length > 0;
    });

  return hasDuplicates;
};

/// Manually sets errors as a workaround for a formik remove bug
export const validateManually = (
  removeItem: (i: number) => void,
  errors: FormikErrors<SubnetMap>,
  setErrors: Function,
  publicIndex: number,
  privateIndex: number = 0,
  validatePublic: boolean = true
) => {
  let errorArray: string[];
  let index: number;

  if (validatePublic) {
    errorArray = errors.publicSubnets as string[];
    index = publicIndex;
  } else {
    index = privateIndex;
    if (errors.publicSubnets) {
      const publicError = errors.publicSubnets[publicIndex] as FormikErrors<
        PublicSubnet
      >;
      errorArray = publicError.privateSubnets as string[];
    } else {
      removeItem(index);
      return;
    }
  }
  removeItem(index);

  //clear errors if there is only one and that row is being removed
  if (
    errorArray &&
    errorArray.filter(e => !!e).length === 1 &&
    errorArray[index]
  ) {
    setErrors({});
  } else {
    setErrors(errors);
  }
};
